"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartPricingChecklist = void 0;
const react_1 = __importStar(require("react"));
const constants_1 = require("../../../tasks/constants");
const index_1 = require("../../../index");
const hui_1 = require("@travelnest/hui");
const tasksInstructionsLookup = {
    [constants_1.Tasks.AMENITIES_FEATURES]: 'Review amenities and features',
    [constants_1.Tasks.LOCATION]: 'Review your location',
    [constants_1.Tasks.PHOTOS]: 'Upload 10 photos',
    [constants_1.Tasks.BEDROOMS]: 'Review your bedrooms',
    [constants_1.Tasks.BATHROOMS]: 'Review your bathrooms',
};
const tasksPathNames = {
    [constants_1.Tasks.AMENITIES_FEATURES]: 'amenities',
    [constants_1.Tasks.LOCATION]: 'location',
    [constants_1.Tasks.PHOTOS]: 'photos',
    [constants_1.Tasks.BEDROOMS]: 'rooms',
    [constants_1.Tasks.BATHROOMS]: 'rooms',
};
const SmartPricingChecklist = ({ tasksValidation, }) => {
    const { propertyId } = (0, react_1.useContext)(index_1.AppContext);
    const filteredTasksValidation = Object.entries(tasksValidation).filter(([_, v]) => v !== true);
    const handleParentRedirect = (url) => {
        window.parent.location.href = url;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, filteredTasksValidation.map(([task]) => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { onClick: () => handleParentRedirect(`/property/${propertyId}/details/${tasksPathNames[task]}`) },
                react_1.default.createElement(hui_1.Chip, { key: task, color: "red", transparent: false, icon: "WarningTriangle", text: tasksInstructionsLookup[task], style: { marginTop: '8px' } }))));
    })));
};
exports.SmartPricingChecklist = SmartPricingChecklist;
//# sourceMappingURL=SmartPricingChecklist.js.map